/**
 * Компонент для отображения изображения в сообщении
 */

import { useState } from 'react';
import { MessageFile } from '@/types/message.types';
import { Lightbox } from '../Lightbox';
import { useImageProxy } from '@/hooks/useImageProxy';
import styles from './MessageImage.module.css';

interface MessageImageProps {
  file: MessageFile;
}

/**
 * Отображает изображение в сообщении с возможностью открытия в Lightbox
 */
export function MessageImage({ file }: MessageImageProps) {
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  
  const { url: blobUrl } = useImageProxy(file.url);

  if (!blobUrl) {
    return (
      <div className={styles.imageContainer}>
        <div className={styles.loading}>
          <div className={styles.skeleton} />
        </div>
      </div>
    );
  }

  return (
    <>
      <div
        className={styles.imageContainer}
        onClick={() => setIsLightboxOpen(true)}
        role="button"
        tabIndex={0}
        aria-label="Открыть изображение"
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            setIsLightboxOpen(true);
          }
        }}
      >
        {!isLoaded && (
          <div className={styles.skeleton} />
        )}
        <img 
          src={blobUrl}
          alt={file.name} 
          className={`${styles.image} ${isLoaded ? styles.loaded : styles.loading}`}
          loading="lazy"
          onLoad={() => setIsLoaded(true)}
        />
        <div className={styles.overlay}>
          <span>Нажмите для увеличения</span>
        </div>
      </div>

      {isLightboxOpen && (
        <Lightbox
          imageUrl={blobUrl}
          filename={file.name}
          onClose={() => setIsLightboxOpen(false)}
        />
      )}
    </>
  );
}

